export default __webpack_public_path__ + "static/media/tiktok.b006a527.png";